import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/welcome.vue';

const routes = [
  {
    path: '/welcome',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/gamepopover',
    name: 'gamepopover',
    component: () =>
      import(/* webpackChunkName: "gamepopover" */ '../views/gamepopover.vue'),
  },
  {
    path: '/tutorials',
    name: 'tutorials',
    component: () =>
      import(/* webpackChunkName: "tutorials" */ '../views/tutorials.vue'),
  },
  {
    path: '/suggest',
    name: 'suggest',
    component: () =>
      import(/* webpackChunkName: "suggest" */ '../views/suggest.vue'),
  },
  {
    path: '/sendvip',
    name: 'sendvip',

    component: () =>
      import(/* webpackChunkName: "sendvip" */ '../views/sendvip.vue'),
  },
  {
    path: '/pay',
    name: 'pay',

    component: () => import(/* webpackChunkName: "pay" */ '../views/pay.vue'),
  },
  {
    path: '/help',
    name: 'help',
    component: () => import(/* webpackChunkName: "help" */ '../views/help.vue'),
  },
  {
    path: '/guide',
    name: 'guide',
    component: () =>
      import(/* webpackChunkName: "guide" */ '../views/guide.vue'),
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: () =>
      import(/* webpackChunkName: "aboutus" */ '../views/aboutus.vue'),
  },
  {
    path: '/aboutai',
    name: 'aboutai',
    component: () =>
      import(/* webpackChunkName: "aboutai" */ '../views/aboutai.vue'),
    meta: {
      title: '关于AI深度合成功能说明',
    },
  },
  {
    path: '/challenge',
    name: 'challenge',
    component: () =>
      import(/* webpackChunkName: "challenge" */ '../views/challenge.vue'),
    meta: {
      title: '模拟挑战',
    },
  },
  {
    path: '/service',
    name: 'service',
    component: () =>
      import(/* webpackChunkName: "service" */ '../views/service.vue'),
    meta: {
      title: '1对1在线服务',
    },
  },
  {
    path: '/agreement/user',
    name: 'agreement/user',
    meta: {
      title: '用户协议',
    },
    component: () =>
      import(
        /* webpackChunkName: "agreement-user" */ '../views/agreement/user.vue'
      ),
  },
  {
    path: '/agreement/privacy',
    name: 'agreement/privacy',
    meta: {
      title: '隐私协议',
    },
    component: () =>
      import(
        /* webpackChunkName: "agreement-privacy" */ '../views/agreement/privacy.vue'
      ),
  },
  {
    path: '/agreement/renewal',
    name: 'agreement/renewal',
    meta: {
      title: '自动续费协议',
    },
    component: () =>
      import(
        /* webpackChunkName: "agreement-renewal" */ '../views/agreement/renewal.vue'
      ),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '亲Key键盘';
  }
});

export default router;
